import * as SettingsActions from '../actions/settings';

export interface State {
	searchType: string;
	showMap: boolean;
	fullScreenMap: boolean;
	showExtendedSearch: boolean;
	openAddToLeafletDialog: { active: boolean, xml: string|null };
}

export const InitialState: State = {
	searchType: 'PA',
	showMap: false,
	fullScreenMap: true,
	showExtendedSearch: true,
	openAddToLeafletDialog: { active: false, xml: null },
};

export function reducer(state: State = InitialState, action: SettingsActions.All): State {
	switch (action.type) {
		case SettingsActions.SWITCH_SEARCH_TYPE:
			return {...state, ...({searchType: action.payload})};

		case SettingsActions.OPEN_ADD_TO_LEAFLET_DIALOG:
			return {...state, ...({ openAddToLeafletDialog: { active: true, xml: action.payload } })};

		case SettingsActions.CLOSE_ADD_TO_LEAFLET_DIALOG:
			return {...state, ...({ openAddToLeafletDialog: { active: false, xml: null } })};

		case SettingsActions.SWITCH_MAP:
			return {...state, ...({showMap: !state.showMap})};

		case SettingsActions.OPEN_MAP:
			return {...state, ...({showMap: true})};

		case SettingsActions.CLOSE_MAP:
			return {...state, ...({showMap: false})};

		case SettingsActions.SWITCH_FULLSCREEN_MAP:
			return {...state, ...({fullScreenMap: !state.fullScreenMap})};

		case SettingsActions.OPEN_FULLSCREEN_MAP:
			return {...state, ...({fullScreenMap: true})};

		case SettingsActions.CLOSE_FULLSCREEN_MAP:
			return {...state, ...({fullScreenMap: false})};

		case SettingsActions.SWITCH_EXTENDED_SEARCH:
			return {...state, ...({showExtendedSearch: !state.showExtendedSearch})};

		case SettingsActions.OPEN_EXTENDED_SEARCH:
			return {...state, ...({showExtendedSearch: true})};

		case SettingsActions.CLOSE_EXTENDED_SEARCH:
			return {...state, ...({showExtendedSearch: false})};

		default:
			return state;
	}
}

export const GetSearchType = (s: State): string => s.searchType;
export const OpenAddToLeafletDialog = (s: State): { active: boolean, xml: string|null } => s.openAddToLeafletDialog;
export const ShowMap = (s: State): boolean => s.showMap;
export const FullscreenMap = (s: State): boolean => s.fullScreenMap;
export const ShowExtendedSearch = (s: State): boolean => s.showExtendedSearch;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/reducers/settings.ts